import { cycle } from '@/lib/cycle';

/** The currencies a campaign budget may be given in, as ISO 4217 codes. */
export const CURRENCIES = ['EUR', 'CHF', 'GBP', 'SEK'] as const;

const POSTER_GRADIENTS = [
  ['#ffd9c2', '#e88aa0', '#7a3b8f'],
  ['#bfe6d8', '#4fa98f', '#0a4f52'],
  ['#dbe8fb', '#4f83d6', '#032453'],
  ['#f6dfae', '#d3902a', '#6b3410'],
  ['#d7f0f6', '#5ab6c9', '#123c56'],
  ['#efe2f8', '#9d6bc4', '#331a52'],
  ['#ffe3d0', '#e0784f', '#5c1f14'],
  ['#e2f4d4', '#7fb04f', '#274012'],
  ['#f2e4de', '#b07a64', '#3e2018'],
] as const;

/** Returns the poster gradient at one index, which wraps around the list. */
export function posterGradient(index: number): string {
  const [from, via, to] = cycle(POSTER_GRADIENTS, index);
  return `radial-gradient(120% 140% at 15% 10%, ${from} 0%, ${via} 48%, ${to} 100%)`;
}
